<ln-ln-pages-armor>
  <section body>
    <ln-hero></ln-hero>

    <div class="mx-auto flex max-w-[1440px] flex-col justify-center">
      <div class="mx-[16px] mt-8 border-t-[0.5px] border-t-verde sm:mx-[70px]"></div>
    </div>

    <ln-ln-special-products></ln-ln-special-products>

    <div class="mx-0 md:mx-[47px] my-12">

  @if (activeLanguage() === Languages.es) {
    <!-- ESPAÑOL -->
    <img
      width="100%"
      class="hidden md:block"
      src="../../../assets/banner-lunaNueva/Web-SomosLunaNueva-Esp.png"
      alt="Luna Nueva"
    />
    <img
      width="100%"
      class="block md:hidden"
      src="../../../assets/banner-lunaNueva/Mob-SomosLunaNueva-Esp.png"
      alt="Luna Nueva"
    />
  } @else {
    <!-- INGLÉS -->
    <img
      width="100%"
      class="hidden md:block"
      src="../../../assets/banner-lunaNueva/Web-SomosLunaNueva-English.png"
      alt="Luna Nueva"
    />
    <img
      width="100%"
      class="block md:hidden"
      src="../../../assets/banner-lunaNueva/Mob-SomosLunaNueva-English.png"
      alt="Luna Nueva"
    />
  }

</div>



    <div class="w-full border-b-[1.8px] border-t-[1.8px] border-b-beige border-t-beige">
      <div class="bg-beige bg-opacity-40 pb-4">
        <div class="mx-auto flex max-w-[1440px] flex-col justify-center">
          <ln-artisans-designers-created-products></ln-artisans-designers-created-products>
        </div>
      </div>
    </div>
  </section>
</ln-ln-pages-armor>
